






















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { tag } from '@/store/modules/tag';
import { compilation } from '@/store/modules/compilation';
import { PlaylistsSelectModalParams } from '@/components/modals/PlaylistsSelectModal.vue';
import { TrackTagsSelectModalParams } from '@/components/modals/TrackTagsSelectModal.vue';
import { CompilationsSelectModalParams } from '@/components/modals/CompilationsSelectModal.vue';
import { SelectMultipleValue } from '@/ui-lib/select-field/SelectField.vue';
import UCheckbox from '@/ui-lib/checkbox/Checkbox.vue';

export interface TrackListFilterValue {
  playlistIDs: number[];
  tagIDs: number[];
  compilationIDs: number[];
  // Ads are uploaded by clients for their own venues and only clutter the music catalogue.
  showAds: boolean;
}

type TrackListFilterField = {
  key: 'playlistIDs' | 'tagIDs' | 'compilationIDs';
  label: string;
  ids: number[];
  names: string[];
  open: () => void;
};

@Component({
  components: {
    UCheckbox
  }
})
export default class TrackListFilter extends Vue {
  @Prop({ required: true })
  private value!: TrackListFilterValue;

  // Playlists, unlike tags and compilations, aren't kept in the store.
  @Prop({ type: Object, default: () => ({}) })
  private playlistTitles!: Record<number, string>;

  private get fields(): TrackListFilterField[] {
    return [
      {
        key: 'playlistIDs',
        label: 'Плейлисты',
        ids: this.value.playlistIDs,
        names: this.value.playlistIDs.map((id) => this.playlistTitles[id] || `#${id}`),
        open: this.openPlaylists
      },
      {
        key: 'tagIDs',
        label: 'Теги',
        ids: this.value.tagIDs,
        names: this.value.tagIDs.map((id) => this.tagNames[id] || `#${id}`),
        open: this.openTags
      },
      {
        key: 'compilationIDs',
        label: 'Подборки',
        ids: this.value.compilationIDs,
        names: this.value.compilationIDs.map((id) => this.compilationNames[id] || `#${id}`),
        open: this.openCompilations
      }
    ];
  }

  private get isActive(): boolean {
    return this.value.showAds || this.fields.some((field) => field.ids.length > 0);
  }

  private get tagNames(): Record<number, string> {
    const names: Record<number, string> = {};
    tag.context(this.$store).state.list.forEach((t) => (names[t.id] = t.name));
    return names;
  }

  private get compilationNames(): Record<number, string> {
    const names: Record<number, string> = {};
    compilation.context(this.$store).state.list.forEach((c) => (names[c.id] = c.name));
    return names;
  }

  private change(patch: Partial<TrackListFilterValue>) {
    this.$emit('change', { ...this.value, ...patch });
  }

  private reset() {
    this.change({ playlistIDs: [], tagIDs: [], compilationIDs: [], showAds: false });
  }

  private openPlaylists() {
    const selected = [...this.value.playlistIDs];

    const params: PlaylistsSelectModalParams = {
      selected,
      submitLabel: 'Применить',
      onSelect: () => this.change({ playlistIDs: selected })
    };

    this.$modal.show('playlists-select', params);
  }

  private openTags() {
    const params: TrackTagsSelectModalParams = {
      selected: this.value.tagIDs.map((id) => ({ id, name: this.tagNames[id] || `#${id}` })),
      allowCreate: false,
      submitLabel: 'Применить',
      onSelect: async (value: SelectMultipleValue) => {
        const list = Array.isArray(value) ? value : value ? [value] : [];
        this.change({ tagIDs: list.map((v) => Number(v.value)) });
      }
    };

    this.$modal.show('track-tags-select', params);
  }

  private openCompilations() {
    const selected = [...this.value.compilationIDs];

    const params: CompilationsSelectModalParams = {
      selected,
      submitLabel: 'Применить',
      onSelect: () => this.change({ compilationIDs: selected })
    };

    this.$modal.show('compilations-select', params);
  }
}
